import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Instagram, Linkedin } from "lucide-react";
import Logo from "@/components/Logo";
import { useSiteSettings, whatsappLink } from "@/lib/SiteSettingsContext";

export default function Footer() {
  const { settings } = useSiteSettings();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#0A2540] text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Logo variant="light" size="md" />
            <p className="text-white/60 text-sm mt-5 leading-relaxed max-w-xs">
              Kimyasal hammaddeden özel formülasyona, laboratuvar testinden seri
              üretime kadar tüm süreçleri tek çatı altında yönetiyoruz.
            </p>
            <div className="flex gap-3 mt-6">
              {settings.instagram && (
                <a
                  href={settings.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="p-2 border border-white/20 hover:border-[#0066FF] hover:text-[#0066FF] transition-colors"
                  data-testid="footer-instagram"
                >
                  <Instagram size={18} />
                </a>
              )}
              {settings.linkedin && (
                <a
                  href={settings.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="p-2 border border-white/20 hover:border-[#0066FF] hover:text-[#0066FF] transition-colors"
                  data-testid="footer-linkedin"
                >
                  <Linkedin size={18} />
                </a>
              )}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">Kurumsal</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/hakkimizda" className="hover:text-[#0066FF] transition-colors" data-testid="footer-link-about">Hakkımızda</Link></li>
              <li><Link to="/sektorler" className="hover:text-[#0066FF] transition-colors" data-testid="footer-link-sectors">Sektörler</Link></li>
              <li><Link to="/iletisim" className="hover:text-[#0066FF] transition-colors" data-testid="footer-link-contact">İletişim</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">Ürünler</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/urunler" className="hover:text-[#0066FF] transition-colors" data-testid="footer-link-products">Tüm Ürünler</Link></li>
              <li><Link to="/urunler?kategori=kozmetik-kimyasallari" className="hover:text-[#0066FF] transition-colors">Kozmetik</Link></li>
              <li><Link to="/urunler?kategori=tekstil-ve-tekstil-yardimci-kimyasallari" className="hover:text-[#0066FF] transition-colors">Tekstil</Link></li>
              <li><Link to="/urunler?kategori=tarim-cevre-ve-veteriner-kimyasallari" className="hover:text-[#0066FF] transition-colors">Tarım</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-white/50 mb-5">İletişim</h4>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex gap-3">
                <MapPin size={16} className="mt-0.5 flex-shrink-0 text-[#0066FF]" />
                <span data-testid="footer-address">{settings.address}</span>
              </li>
              <li>
                <a
                  href={`tel:${settings.phone?.replace(/\s/g, "")}`}
                  className="flex gap-3 hover:text-[#0066FF] transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={16} className="mt-0.5 text-[#0066FF]" />
                  <span>{settings.phone}</span>
                </a>
              </li>
              {settings.email && (
                <li>
                  <a
                    href={`mailto:${settings.email}`}
                    className="flex gap-3 hover:text-[#0066FF] transition-colors"
                    data-testid="footer-email"
                  >
                    <Mail size={16} className="mt-0.5 text-[#0066FF]" />
                    <span>{settings.email}</span>
                  </a>
                </li>
              )}
              <li>
                <a
                  href={whatsappLink(settings.whatsapp)}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 mt-3 bg-[#25D366] hover:bg-[#1ea855] text-white px-4 py-2 text-sm font-semibold transition-colors"
                  data-testid="footer-whatsapp"
                >
                  WhatsApp ile Yazın
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-14 pt-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
          <span>© {year} Güven Kimya. Tüm hakları saklıdır.</span>
          <div className="flex items-center gap-4">
            <Link to="/admin/login" className="hover:text-white transition-colors" data-testid="footer-admin-link">
              Yönetici Girişi
            </Link>
            <span className="text-white/20">·</span>
            <span>Aksaray · Türkiye</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
